import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { NewsletterIssues } from './NewsletterIssues';
export function ResourcesNewsletter() {
  return <section className="w-full bg-brand-light-gray py-12 md:py-14 px-4 sm:px-6 lg:px-8" data-id="element-175" data-mp="jbfdb8p25u7p">
      <div className="max-w-4xl mx-auto" data-id="element-176" data-mp="eckkrf1agrae">
        <div className="bg-white p-10 md:p-16 rounded-lg shadow-sm border-t-4 border-brand-orange" data-id="element-177" data-mp="9fknntmf2yvf">
          <h2 className="text-4xl md:text-5xl font-bold text-brand-navy mb-8" data-id="element-178" data-mp="5dh38fhrsjy0">
            Broken Pencils
          </h2>
          <p className="text-xl text-brand-gray leading-relaxed mb-12" data-id="element-179" data-mp="lzb8gxq5tp6">
            A newsletter about AI transformation, leadership, and the
            messy reality of getting teams to work differently. Published every
            other week. Read by leaders figuring out what AI means for how
            their teams work.
          </p>

          <div className="bg-brand-light-gray p-8 rounded-lg mb-10 border border-gray-100 shadow-sm" data-id="element-180" data-mp="3hx8fqw64qq3w">
            <iframe src="https://embeds.beehiiv.com/792bb15f-3a0a-4874-bffc-3a18450d8d36?slim=true" data-test-id="beehiiv-embed" height="52" frameBorder="0" scrolling="no" style={{
            margin: 0,
            borderRadius: '0px',
            backgroundColor: 'transparent',
            width: '100%'
          }} data-id="element-181" data-mp="3dvn6rlwpuvyz"></iframe>
          </div>

          <NewsletterIssues data-id="element-182" data-mp="6l8vjscwmvmc" />

          <a href="https://newsletter.breakapencil.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center font-bold text-brand-orange hover:text-brand-orange-hover transition-colors text-lg" data-id="element-183" data-mp="6hus0gsi8gdb">
            Read past issues
            <ArrowRightIcon className="w-5 h-5 ml-2" data-id="element-184" data-mp="1mp81ninxbrv" />
          </a>
        </div>
      </div>
    </section>;
}